/* ••[1]••••••••••••••••••••••••• VanillaAnnouncementsProvider.ts •••••••••••••••••••••••••••••• */

import VanillaProvider from "./VanillaProvider";
import FetchSettings from "../../../interfaces/FetchSettings";
import {
  VanillaDiscussion,
  VanillaDiscussionsPage,
} from "./../../../interfaces/VanillaApi";
import { getMode, linkParser } from "../../../utilities";

export default class VanillaDiscussionsProvider extends VanillaProvider {
  public async getDiscussionsByCat(
    idCat: number,
    limit = 5,
    tags: Array<string> = [],
    announcements = false,
    afterDate: Date = null,
    page = -1
  ): Promise<VanillaDiscussionsPage> {
    const apiUrl = this.baseUrl + (tags.length > 0 ? "search" : "discussions");
    const url = new URL(apiUrl);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const searchParams = new URLSearchParams();
    searchParams.append("limit", limit.toString());
    searchParams.append("categoryID", idCat.toString());
    if (tags.length > 0) {
      searchParams.append("recordTypes[]", "discussion");
      // searchParams.append("types[]", "discussion");
      searchParams.append("tagOperator", "or");
      tags.forEach((tag, idx) => {
        searchParams.append(`tags[${idx}]`, tag);
      });
    } else {
      // only available on discussions endpoint
      searchParams.append("sort", "-dateLastComment");
      if (announcements) {
        searchParams.append("announcement", "true");
      }
    }
    if (afterDate !== null) {
      searchParams.append(
        "dateInserted",
        `>=${afterDate.getFullYear()}-${afterDate.getMonth()}-${afterDate.getDate()}`
      );
    }
    if (page && page > -1) {
      searchParams.append("page", page + "");
    } else {
      searchParams.append("page", "1");
    }
    url.search = new URLSearchParams(searchParams).toString();
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const response: Response = await this.request(
      url.toString(),
      settings,
      true
    );

    if (response.status !== 200) {
      throw (
        "Failed call to get discussions by category. Status " + response.status
      );
    }

    // const links = '<https://community-dev.oracle.com/ccc-test/api/v2/search?page=1&limit=2&recordTypes%5B0%5D=discussion&types%5B0%5D=discussion&categoryID=10&tags%5B0%5D=Report+Sharing+Center&tagOperator=or>; rel="first", <https://community-dev.oracle.com/ccc-test/api/v2/search?page=2&limit=2&recordTypes%5B0%5D=discussion&types%5B0%5D=discussion&categoryID=10&tags%5B0%5D=Report+Sharing+Center&tagOperator=or>; rel="next", <https://community-dev.oracle.com/ccc-test/api/v2/search?page=9&limit=2&recordTypes%5B0%5D=discussion&types%5B0%5D=discussion&categoryID=10&tags%5B0%5D=Report+Sharing+Center&tagOperator=or>; rel="last"';
    const links = response.headers.get("link");
    const data = await response.json();

    // console.debug("LoadedLinks", response);
    // console.debug("LoadedLinks", links);

    return { data: data, pagination: linkParser(links) };
  }

  public async searchDiscussions(
    query: string,
    categoryId: number = null,
    page = 1,
    limit = 10
  ): Promise<Array<VanillaDiscussion>> {
    const apiUrl = this.baseUrl + "search";
    const url = new URL(apiUrl);
    const searchParams = new URLSearchParams();
    searchParams.append("query", query);
    if (categoryId) {
      searchParams.append("categoryID", categoryId.toString());
    }
    searchParams.append("limit", limit.toString());
    searchParams.append("page", page.toString());
    searchParams.append("recordTypes[]", "discussion");
    if (getMode() === "development") {
      searchParams.append(
        "access_token",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    url.search = new URLSearchParams(searchParams).toString();
    const settings: FetchSettings = {
      method: "GET",
    };
    const response: Response = await this.request(
      url.toString(),
      settings,
      true
    );
    if (response.status !== 200) {
      throw "Failed call to search discussions. Status " + response.status;
    }
    const data = await response.json();
    return data;
  }
}
